import { Link } from 'react-router-dom';

const footerLinks = {
  content: [
    { label: '情感倾诉', to: '/category/qinggan-qingsu' },
    { label: '生活故事', to: '/category/shenghuo-gushi' },
    { label: '同城交友', to: '/category/tongcheng-jiaoyou' },
    { label: '心灵成长', to: '/category/xinling-chengzhang' },
    { label: '家庭关系', to: '/category/jiating-guanxi' },
    { label: '职场人生', to: '/category/zhichang-rensheng' },
  ],
  about: [
    { label: '关于我们', to: '/about' },
    { label: '用户协议', to: '/about' },
    { label: '隐私政策', to: '/about' },
    { label: '帮助中心', to: '/about' },
  ],
};

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-background-900 text-background-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center bg-primary-500 text-background-50 rounded-lg font-bold text-sm">
                海
              </span>
              <span className="text-lg font-heading font-semibold text-background-50 whitespace-nowrap">
                海角社区
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              真实用户聚集的情感交流平台，在这里找到理解与共鸣，分享你的真实故事与生活感悟。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">内容板块</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.content.map((link) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">关于</h4>
            <ul className="flex flex-col gap-2">
              {footerLinks.about.map((link) => (
                <li key={link.label}>
                  <Link
                    to={link.to}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-3 text-sm text-background-400">
              <div className="flex items-center gap-2">
                <i className="ri-mail-line text-base"></i>
                <span>contact@haijiao.cn</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-phone-line text-base"></i>
                <span>400-888-6666</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line text-base"></i>
                <span>杭州市西湖区文三路478号</span>
              </div>
            </div>
            <div className="flex items-center gap-3 mt-4">
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                aria-label="微信"
                rel="nofollow"
              >
                <i className="ri-wechat-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                aria-label="微博"
                rel="nofollow"
              >
                <i className="ri-weibo-line"></i>
              </a>
              <a
                href="#"
                className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200 cursor-pointer"
                aria-label="QQ"
                rel="nofollow"
              >
                <i className="ri-qq-line"></i>
              </a>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {currentYear} 海角社区 版权所有 | 浙ICP备2024000000号
          </p>
          <p className="text-xs text-background-500">
            用心倾听每一个故事，用爱温暖每一颗心灵
          </p>
        </div>
      </div>
    </footer>
  );
}